import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpEvent, HttpHandler, HttpInterceptor } from '@angular/common/http';
import { Observable} from 'rxjs';
import { finalize} from 'rxjs/operators';

import { OngoingRequestTrackerService } from '@core';

import { HeaderName } from '../constants/header-name.enum';


@Injectable()
export class OngoingRequestTrackingInterceptor implements HttpInterceptor {
    private readonly ongoingRequestTracker = inject(OngoingRequestTrackerService);


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.isBackgroundRequest(request)) {
            this.ongoingRequestTracker.trackRequestStarted();
        }

        return next.handle(request)
            .pipe(finalize(()  => {
                if (!this.isBackgroundRequest(request)) {
                    this.ongoingRequestTracker.trackRequestDone();
                }
            }));
    }

    private isBackgroundRequest(request: HttpRequest<any>): boolean {
        // todo after upgrade to Angular 12 use a custom HTTP request context attribute instead of a header
        return request.headers.has(HeaderName.IsBackgroundRequest);
    }
}
